// import React from "react";
// import {
//   LineChart,
//   Line,
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell,
// } from "recharts";

// /* ===================== DUMMY DATA ===================== */
// const revenueData = [
//   { month: "Jan", revenue: 8000, lastYear: 2000 },
//   { month: "Feb", revenue: 4000, lastYear: 9000 },
//   { month: "Mar", revenue: 11000, lastYear: 17000 },
//   { month: "Apr", revenue: 21000, lastYear: 3000 },
//   { month: "May", revenue: 25000, lastYear: 11000 },
//   { month: "Jun", revenue: 19000, lastYear: 21000 },
//   { month: "Jul", revenue: 20000, lastYear: 27000 },
// ];

// const categoryData = [
//   { name: "Electronics", value: 1200000, color: "#2563EB" },
//   { name: "Fashion", value: 950000, color: "#3B82F6" },
//   { name: "Home & Kitchen", value: 750000, color: "#60A5FA" },
//   { name: "Beauty & Personal Care", value: 500000, color: "#BFDBFE" },
// ];

// const totalSales = "100k";

// /* ===================== COMPONENT ===================== */
// const RevenueAnalyticsSection = () => {
//   return (
//     <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
      
//       {/* ===================== REVENUE ANALYTICS ===================== */}
//       <div className="xl:col-span-2 bg-[#F7F9FB] rounded-2xl p-6">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-sm font-semibold text-gray-800">
//             Revenue Analytics
//           </h3>

//           <button className="bg-blue-600 text-white text-xs px-3 py-1.5 rounded-md">
//             Last year ▾
//           </button>
//         </div>

//         <div className="h-[260px]">
//           <ResponsiveContainer width="100%" height="100%">
//             <AreaChart data={revenueData}>
//               <defs>
//                 <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#3B82F6" stopOpacity={0.3} />
//                   <stop offset="100%" stopColor="#3B82F6" stopOpacity={0} />
//                 </linearGradient>
//               </defs>

//               <XAxis dataKey="month" axisLine={false} tickLine={false} />
//               <YAxis
//                 axisLine={false}
//                 tickLine={false}
//                 tickFormatter={(v) => `${v / 1000}K`}
//               />
//               <Tooltip />

//               <Area
//                 type="monotone"
//                 dataKey="revenue"
//                 stroke="#2563EB"
//                 strokeWidth={2}
//                 fill="url(#colorRevenue)"
//               />

//               <Line
//                 type="monotone"
//                 dataKey="lastYear"
//                 stroke="#60A5FA"
//                 strokeDasharray="4 4"
//                 strokeWidth={2}
//                 dot={false}
//               />
//             </AreaChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       {/* ===================== TOP CATEGORIES ===================== */}
//       <div className="bg-[#F7F9FB] rounded-2xl p-6 shadow-sm">
//         <div className="flex justify-between items-center mb-4">
//           <h3 className="text-sm font-semibold text-gray-800">
//             Top Categories
//           </h3>
//           <button className="text-xs text-gray-400 hover:underline">
//             See All
//           </button>
//         </div>

//         {/* DONUT */}
//         <div className="flex justify-center items-center relative h-[220px]">
//           <PieChart width={220} height={220}>
//             <Pie
//               data={categoryData}
//               innerRadius={70}
//               outerRadius={90}
//               paddingAngle={6}
//               dataKey="value"
//             >
//               {categoryData.map((entry, index) => (
//                 <Cell key={index} fill={entry.color} />
//               ))}
//             </Pie>
//           </PieChart>

//           {/* CENTER TEXT */}
//           <div className="absolute text-center">
//             <p className="text-lg font-bold">{totalSales}</p>
//             <p className="text-xs text-gray-400">Total Sales</p>
//           </div>
//         </div>

//         {/* LEGEND */}
//         <div className="space-y-2 mt-4">
//           {categoryData.map((cat) => (
//             <div
//               key={cat.name}
//               className="flex justify-between items-center text-xs"
//             >
//               <div className="flex items-center gap-2">
//                 <span
//                   className="w-2.5 h-2.5 rounded-full"
//                   style={{ backgroundColor: cat.color }}
//                 />
//                 <span className="text-gray-600">{cat.name}</span>
//               </div>
//               <span className="text-gray-700 font-medium">
//                 ₹{cat.value.toLocaleString()}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RevenueAnalyticsSection;


import React, { useEffect, useState, useMemo } from "react";
import {
  AreaChart,
  Area,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import SelectDropdown from "../../customStyles/SelectDropdown";

/* ===================== CONSTANTS ===================== */
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const yearOptions = [
  { label: "Last 2 years", value: 2 },
  { label: "Last 3 years", value: 3 },
  { label: "Last 4 years", value: 4 },
];

// better contrast colors
const COLORS = [
  "#2563EB", // latest
  "#22C55E",
  "#F97316",
  "#A855F7",
];
const COLORS1 = ["#2563EB","#3B82F6","#60A5FA","#93C5FD","#BFDBFE"];
/* ===================== COMPONENT ===================== */
const RevenueAnalyticsSection = () => {
  const [years, setYears] = useState(2);
  const [rawData, setRawData] = useState({});
  const [loading, setLoading] = useState(false);
  const [topCategories, setTopCategories] = useState([]);
  const [totalSales, setTotalSales] = useState(0);

  /* ===================== FETCH DATA ===================== */
  const fetchRevenue = async (y) => {
    try {
      setLoading(true);
      const res = await api({
        url: SummaryApi.getRevenueComparison.url,
        method: SummaryApi.getRevenueComparison.method,
        params: { years: y },
      });

      if (res.data?.success) {
        setRawData(res.data.data);
      }
    } catch (err) {
      console.error("Revenue fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRevenue(years);
  }, [years]);

  const fetchTopCategories = async () => {
    try {
      const res = await api({
        url: SummaryApi.getTopCategoriesRevenue.url,
        method: SummaryApi.getTopCategoriesRevenue.method
      });

      if (res.data?.success) {
        setTopCategories(res.data.categories || []);
        setTotalSales(res.data.totalSales || 0);
      }
    } catch (err) {
      console.error("Top categories fetch error", err);
    }
  };

  useEffect(() => {
    fetchTopCategories();
  }, []);

  /* ===================== TRANSFORM DATA ===================== */
  const chartData = useMemo(() => {
    if (!rawData || Object.keys(rawData).length === 0) return [];

    return MONTHS.map((month) => {
      const row = { month };
      Object.keys(rawData).forEach((year) => {
        row[year] = rawData[year][month] || 0;
      });
      return row;
    });
  }, [rawData]);

  const yearsList = Object.keys(rawData);

  const pieData = topCategories.map((cat, index) => ({
    ...cat,
    color: COLORS1[index % COLORS1.length]
  }));

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">

      {/* ===================== REVENUE ANALYTICS ===================== */}
      <div className="xl:col-span-2 bg-[#F7F9FB] rounded-2xl p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-sm font-semibold text-gray-800">
            Revenue Analytics
          </h3>

          {/* FILTER */}
        <SelectDropdown
          options={yearOptions}
          value={years}
          onChange={setYears}
          labelKey="label"
          valueKey="value"   // 🔥 IMPORTANT
          parentClassName="!w-[140px]"
          ChildClassName="!bg-blue-600 text-white text-xs !px-3 !py-1.5 rounded-md"
          dropdownClassName="!min-w-[140px]"
        />

        </div>

        <div className="h-[260px]">
          {loading ? (
            <div className="flex items-center justify-center h-full text-sm text-gray-400">
              Loading revenue...
            </div>
          ) : (
          // <ResponsiveContainer width="100%" height="100%">
          //   <AreaChart data={chartData} >
          //     <XAxis dataKey="month" axisLine={false} tickLine={false} padding={{ left: 15, right: 10 }}/>
          //     <YAxis
          //       axisLine={false}
          //       tickLine={false}
          //       padding={{ top: 10, bottom: 10 }}
          //       tickFormatter={(v) => `${v / 1000}K`}
          //     />

          //     <Tooltip />

          //     {yearsList.map((year, index) => {
          //       const isLatest = index === yearsList.length - 1;

          //       return (
          //         <Line
          //           key={year}
          //           type="monotone"
          //           dataKey={year}
          //           stroke={COLORS[index]}
          //           strokeWidth={isLatest ? 3 : 2}
          //           strokeDasharray={isLatest ? "0" : "4 4"}
          //           dot={false}
          //         />
          //       );
          //     })}

          //     {yearsList.length > 0 && (
          //     <Area
          //       type="monotone"
          //       dataKey="__latestArea"
          //       stroke="none"
          //       fill={COLORS[0]}
          //       fillOpacity={0.15}
          //       isAnimationActive
          //     />

          //     )}
          //   </AreaChart>
          // </ResponsiveContainer>
<div className="w-full overflow-x-auto scrollbar-hide">
  <div className="min-w-[700px] h-[260px]">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={chartData}
        // margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
      >
        <XAxis
          dataKey="month"
          interval={0}
          axisLine={false}
          tickLine={false}
          tickMargin={8}
          padding={{ left: 15, right: 10 }}
        />

        <YAxis
          axisLine={false}
          tickLine={false}
          tickFormatter={(v) => `${v / 1000}K`}
        />

        <Tooltip />

        {yearsList.map((year, index) => {
          const isLatest = index === yearsList.length - 1;
          return (
            <Line
              key={year}
              type="monotone"
              dataKey={year}
              stroke={COLORS[index]}
              strokeWidth={isLatest ? 3 : 2}
              strokeDasharray={isLatest ? "0" : "4 4"}
              dot={false}
            />
          );
        })}

        {yearsList.length > 0 && (
          <Area
            type="monotone"
            dataKey="__latestArea"
            stroke="none"
            fill={COLORS[0]}
            fillOpacity={0.15}
          />
        )}
      </AreaChart>
    </ResponsiveContainer>
  </div>
</div>

          )}
        </div>
      </div>

      {/* ===================== TOP CATEGORIES (DUMMY) ===================== */}
      <div className="bg-[#F7F9FB] rounded-2xl p-6 shadow-sm">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-sm font-semibold text-gray-800">
            Top Categories
          </h3>
          <button className="text-xs text-gray-400 hover:underline">
            See All
          </button>
        </div>

        {/* DONUT */}
        <div className="flex justify-center items-center relative h-[220px]">
          <PieChart width={220} height={220}>
            <Pie
              data={pieData}
              innerRadius={70}
              outerRadius={90}
              paddingAngle={6}
              dataKey="value"
            >
              {pieData.map((entry, index) => (
                <Cell key={index} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>

          {/* CENTER TEXT */}
          <div className="absolute text-center">
            <p className="text-lg font-bold">
              ₹{totalSales.toLocaleString()}
            </p>
            <p className="text-xs text-gray-400">Total Sales</p>
          </div>
        </div>

        {/* LEGEND */}
        <div className="space-y-2 mt-4">
          {pieData.map((cat) => (
            <div
              key={cat.name}
              className="flex justify-between items-center text-xs"
            >
              <div className="flex items-center gap-2">
                <span
                  className="w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: cat.color }}
                />
                <span className="text-gray-600">{cat.name}</span>
              </div>
              <span className="text-gray-700 font-medium">
                ₹{cat.value.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RevenueAnalyticsSection;
